import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { Bien } from 'src/app/models/Bien';
import { biTypologieDto } from 'src/app/models/biTypologieDto';
import { Ope } from 'src/app/models/Ope';
import { SearchOpeBiCriteria } from 'src/app/models/SearchOpeBiCriteria';
import { vignetteOpe } from 'src/app/models/vignetteOpe';
import { DocServices } from 'src/app/services/docs/docs.services';
import { ImageCacheService } from 'src/app/services/imageCache.service';
import { OpeService } from 'src/app/services/ope/ope.service';
import { PersistanceService } from 'src/app/services/persistenceStorage/localstorage.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  imports : [CommonModule,BadgeModule,OverlayBadgeModule,RouterModule],
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  nom!: string;
  adresse1!: string;
  ville!: string;
  code!: string;
  date!: string;
  descCommerciale!: string;
  totalLot!: number;
  totalDispo!: number;
  totalOptions!: number;
  criterisa!: SearchOpeBiCriteria;
  imageLoaded = false;

  @Input()
  //public programmeSelected!: Programme;
  public programmeSelected!: Ope;
  listebien!: Bien[];
  dateprevLivraison!: string;
  yearpre!: string;
  moispre!: string;
  jourspre!: string;
  typeAbrgd!: biTypologieDto[];

  prixlist: any;
  prixstart!: number;
  prixtodisplay!: string;
  descriptionStatut!: string;
  minTypeLot: any;
  maxTypeLot!: string;
  vignettedetails!: vignetteOpe[];
  urlImageVig: string | undefined;
  dataImageVig: string | undefined;
  vignetteope!: vignetteOpe;
  listvignette: vignetteOpe[] = [];
  private destroy$!: Subject<boolean>;
  private cache: Record<number, any[]> = {};

  constructor(public share: shareOpeSevices, public opeservice: OpeService, public route: Router, private readonly docsndVigneteService: DocServices,
    private persist: PersistanceService, private imageCacheService: ImageCacheService) {

  }
  ngOnInit() {


    this.destroy$ = new Subject<boolean>();
    this.totalDispo = this.programmeSelected.disponibles;
    this.totalLot = this.programmeSelected.totalLots;
    this.totalOptions = this.programmeSelected.optionnes;
    this.dateprevLivraison = this.programmeSelected.dateLivraison;
    this.minTypeLot = this.programmeSelected.minTypeLot;
    this.maxTypeLot = this.programmeSelected.maxTypeLot;
    // setter et transformer la date de livraison!
    this.moispre = this.dateprevLivraison.substring(5, 7);
    this.yearpre = this.dateprevLivraison.substring(0, 4);
    this.jourspre = this.dateprevLivraison.substring(8, 10);
    this.date = `${this.jourspre}/${this.moispre}/${this.yearpre}`;

    //setter le prix minim dans le programme
    this.prixlist = this.programmeSelected.prixMin;
    this.prixtodisplay = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(this.prixlist * 1.2);

    this.descriptionStatut = this.changeDescription();

    //this.getUrlVignette_img(this.programmeSelected.numOpe,this.programmeSelected.nom);

    this.docsndVigneteService.getFirVignetteBynumOpe(this.programmeSelected.numOpe).subscribe(async res => {
      this.vignetteope = res;
      //this.urlImageVig = this.vignetteope.url;
      this.urlImageVig = this.vignetteope.url;
      this.dataImageVig = await this.imageCacheService.fetchAndCache(this.vignetteope.url);
      /*this.vignetteope = JSON.parse(window.localStorage.getItem(this.programmeSelected.nom) as string);   */
      window.localStorage.setItem(this.programmeSelected.nom, JSON.stringify(this.vignetteope));
    })



    /*if(!window.localStorage.getItem(this.programmeSelected.nom)){
    this.getUrlVignette_img(this.programmeSelected.numOpe,this.programmeSelected.nom);
    }
    else{
     
      this.vignetteope = JSON.parse(window.localStorage.getItem(this.programmeSelected.nom) as string);   
      if(this.vignetteope!=null)
        if(this.vignetteope.url)
          this.urlImageVig = this.vignetteope.url;
      }*/


  }

  sendOpeclick() {

    // envoyer l ope selectionné à page-programme
    // attention , si besoin d envoyer une nouvelle variabel , il faut tjrs creer un observable et s'abboner dans le Share .
    this.share.sendOpeN(this.programmeSelected);
    //this.share.sendVignetteDetails(JSON.parse(window.localStorage.getItem(this.programmeSelected.nom) as string));
    this.share.sendVignetteDetails(JSON.parse(window.localStorage.getItem(this.programmeSelected.nom) as string));
    this.share.sendTabProgOpe("prez");

  }

  sendOpeclickOut(prog: Ope) {

    // envoyer l ope selectionné à page-programme
    // attention , si besoin d envoyer une nouvelle variabel , il faut tjrs creer un observable et s'abboner dans le Share .

    this.share.sendOpeN(prog);
    this.share.sendVignetteDetails(JSON.parse(window.localStorage.getItem(prog.nom) as string));
    this.route.navigateByUrl("/page-programme");

  }

  sendOpeclickOps() {
    this.share.sendOpeN(this.programmeSelected);
    //this.share.sendVignetteDetails(JSON.parse(window.localStorage.getItem(this.programmeSelected.nom) as string));
    this.share.sendVignetteDetails(JSON.parse(window.localStorage.getItem(this.programmeSelected.nom) as string));
    this.share.sendTabProgOpe("options");
  }

  changeDescription() {

    if ((this.maxTypeLot !== this.minTypeLot) || (this.maxTypeLot !== '')) {
      return `Du ${this.minTypeLot} au ${this.maxTypeLot}`
    }
    else { return "Du " + this.minTypeLot }
  }

  // move to package util
  removeNull(array: any[]) {
    array.forEach((v, i) => {
      if (v === '0' || v === null) {
        array.shift();
      } else {
        array.splice(v - 1, 1);
      }
    })
  }

  getUrlVignette_img(data: number, keylocal: string) {

    this.docsndVigneteService.getFirVignetteBynumOpe(data).subscribe(res => {
      this.vignetteope = res;
      //this.urlImageVig = this.vignetteope.url;
      this.urlImageVig = this.vignetteope.url;
      this.dataImageVig = (this.imageCacheService.fetchAndCache(this.vignetteope.url) as unknown) as string ?? this.urlImageVig;
      /*this.vignetteope = JSON.parse(window.localStorage.getItem(this.programmeSelected.nom) as string);   */
      //window.localStorage.setItem(this.programmeSelected.nom, JSON.stringify(this.vignetteope));
    })
  }


  sortArraybyObjValue = (arr: any[], value: string | number) => {
    //return an array with object sorted by value 
    //sort by object key that matches the value 
    //we will move this to package utils
    return arr.sort((a, b) => {
      return a[value] - b[value];
      //return a[value] < b[value] ? -1 : a[value] > b[value] ? 1: 0
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}